<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [attr.data-testid]="'item_groupings_search_bar'"
    [displaySearchWithOptions]="false"
    [fields]="fields"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    layout-center-header
    (add)="openCreateItemGroupingForm()"
    (filter)="onFilter($event)"
  ></emm-search-filter>
  <emm-generic-items-tree
    [contextMenuActions]="itemGroupingsContextMenuActions"
    [disableContextActions]="centerLoading$ | async"
    [disableDefaultOnMove]="true"
    [items]="nodes$ | async"
    layout-center-content
    [options]="options"
    [readonly]="(isReadOnly$ | async) || isMMSAuthor"
    [isMmsAuthorOnly]="isMMSAuthor"
  ></emm-generic-items-tree>
  @if (!addClicked && (itemDetail$ | async); as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
      [type]="item.itemType"
    ></emm-management-attributes-header>
  }
  @if (!addClicked && (itemDetail$ | async); as item) {
    <emm-items-form
      #form
      layout-right-content
      [selectedItem]="item"
    ></emm-items-form>
  }
  @if (addClicked) {
    <emm-management-attributes-header
      layout-right-header
      [name]="'New Item Grouping'"
      [tag]="'TBD'"
      [type]="'TBD'"
    ></emm-management-attributes-header>
  }
  @if (addClicked) {
    <emm-item-creation-form
      #form
      layout-right-content
      [attributes]="globalAttributes"
      [previousAttributeGroups]="previousAttributeGroups$ | async"
      (attributeGroupSelected)="onAttributeGroupSelected($event)"
      (cancelClicked)="addClicked = false"
      (submissionFinished)="onCreateFinished()"
    ></emm-item-creation-form>
  }
</emm-management-layout>
